import React from 'react';
import classNames from 'classnames/bind';
import styles from './Diversidad.module.scss';
import CDNImage from '../../utils/CDNImage';

let cx = classNames.bind(styles);

const Diversidad = () => {
	return (
		<section
			id='nosotros'
			className={cx({ diversidad: true, 'hidden lg:block mt-10 py-10': true })}
		>
			<div className='container mx-auto flex flex-col justify-start items-center'>
				<h1 className='text-tcn-dark-blue font-Avenir-Heavy text-5xl py-4'>
					<strong className='font-Avenir-Black'>DIVERSIDAD E INCLUSIÓN</strong>
				</h1>
				<p className='text-tcn-dark-blue text-center px-48 py-10 font-Avenir-Black'>
					Estamos convencidos que la diversidad nos enriquece y la inclusión nos
					fortalece, buscamos de ir más allá de la tolerancia buscando un lugar
					donde todas las personas se sientan parte y tengan las mismas
					oportunidades de desarrollo, siendo libres de ser ellos mismos.
				</p>
			</div>
			<div className='container mx-auto w-full flex flex-col flex-wrap'>
				<h1 className='text-tcn-dark-blue font-Avenir-Heavy text-5xl py-4'>
					<strong className='font-Avenir-Black'>En Chile:</strong>
				</h1>
				<div className='flex flex-row'>
					<div className='flex w-2/6'>
						<CDNImage
							className=''
							image_name={'Comunidad_global_.png'}
							alt='Comunidad_global'
						/>
					</div>
					<div className='flex w-3/6 justify-center'>
						<CDNImage
							className=''
							image_name={'Promovemos_la_equidad.png'}
							alt='Comunidad_global'
						/>
					</div>
				</div>
				<div className='flex flex-row'>
					<div className='flex w-3/6 justify-end'>
						<CDNImage
							className=''
							image_name={'Personas_con_discapacidad.png'}
							alt='Comunidad_global'
						/>
					</div>
					<div className='flex w-3/6 justify-center'>
						<a
							href='https://tcn-assets.hiperjob.com/ideal/documentos/Fundamentos.pdf'
							download
							target='_blank'
							rel='noopener noreferrer'
						>
							<CDNImage
								className='mx-4'
								image_name={'Fundamentos.png'}
								alt='Comunidad_global'
							/>
						</a>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Diversidad;
